<template>
  <form @submit.prevent="submit()">
    <b-row>

      <b-col lg="6" sm="12">
        <b-form-group>
          <label for="title">{{ $t('global.title') }}</label>
          <input type="text" id="title" class="form-control" v-model="item.surveyTitle" :placeholder="$t('global.title')">
          <div v-if="isInvalid('title')" class="text-danger">
            {{ violations.surveyTitle }}
          </div>
        </b-form-group>
      </b-col>

      <b-col lg="6" sm="12">
        <b-form-group>
          <label for="description">{{ $t('global.description') }}</label>
          <input type="text" id="description" class="form-control" v-model="item.surveyDescription" :placeholder="$t('global.description')">
          <div v-if="isInvalid('description')" class="text-danger">
            {{ violations.surveyDescription }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <hr class="my-2">
    <b-row v-if="item['@id']">
      <b-col class="px-5 py-3">
        <document-files :path="'api/e_x_a_b_surveys/'" :item="item" :fetch-data="() => this.retrieve(decodeURIComponent(this.$route.params.id))"></document-files>
      </b-col>
      <hr class="my-2">
    </b-row>
    <b-row v-if="item.form">
      <b-col cols="12">
        <b-tabs>
          <b-tab v-for="(questionGroup, key) in item.form.surveyGroupsQuestions" :key="key">
            <template v-slot:title>
              <h6>{{$t('views.surveys.form.questionGroup')}} - {{ key+1 }}</h6>
              <b-button class="btn-block mt-4" variant="danger" @click="removeItemCollection(key, 'surveyGroupsQuestions')">
                <i class="fa fa-trash mr-2"></i>{{$t('buttons.delete')}}
              </b-button>
            </template>
            <survey-groups-questions :question-group="questionGroup" v-model="item.form.surveyGroupsQuestions[key]"></survey-groups-questions>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col cols="12">
        <b-button variant="primary" class="btn-block mt-4" @click="addNewItemCollection('surveyGroupsQuestions')">
          <i class="fa fa-plus mr-2"></i>{{ $t('buttons.addTab') }}
        </b-button>
      </b-col>
    </b-row>
    <button type="button" class="btn btn-success" @click="submit()">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>

import SurveyGroupsQuestions from '@/components/Dashboard/Views/AgreementsBundle/surveys/components/surveyGroupsQuestions.vue'
import DocumentFiles from '@/components/Dashboard/Views/common/DocumentFiles.vue'

export default {
  name: 'Form',
  props: ['values', 'initialValues', 'handleSubmit', 'violations', 'retrieve'],
  components: {
    DocumentFiles,
    SurveyGroupsQuestions
    // Trumbowyg
  },
  data () {
    return {
      initialObject: {},
      emailContentVisible: null,
      trumbowygConfig: {
        semantic: false,
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdowns
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule']
        ],
        lang: this.$i18n.locale
      }
    }
  },
  watch: {
  },
  computed: {
    item () {
      return typeof this.values !== 'undefined' ? this.values : this.initialObject
    },
    isEmailContentVisible: {
      get () {
        return Boolean(this.item.customEmail)
      },
      set (val) {
        this.emailContentVisible = val
      }
    }
  },
  created () {
  },
  methods: {
    addNewItemCollection (type) {
      let objectGD
      if (type === 'surveyGroupsQuestions') {
        if (this.item.form.surveyGroupsQuestions === null || this.item.form.surveyGroupsQuestions === undefined) {
          this.item.form.surveyGroupsQuestions = []
        }
        objectGD = {
          title: '',
          description: '',
          hasDocument: 0,
          surveyQuestions: [
            {
              questionDescription: '',
              questionType: 1,
              surveyQuestionAnswers: [],
              required: 0
            }
          ]
        }
        this.item.form.surveyGroupsQuestions.push(objectGD)
      }
    },
    removeItemCollection (itemIndex, type) {
      if (type === 'surveyGroupsQuestions') {
        this.item.form.surveyGroupsQuestions.splice(itemIndex, 1)
      }
    },
    submit () {
      let finalObject = JSON.parse(JSON.stringify(this.item))
      finalObject.form = JSON.stringify(finalObject.form)
      this.$emit('submit', finalObject)
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>

<style scoped>
</style>
